import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Card, CardContent } from "@/components/ui/card";

interface SubCategory {
  sub_handle: string;
  sub_title: string;
  category_handle: string;
  image_url: string | null;
}

interface SubCategoryListProps {
  categoryHandle: string;
}

export function SubCategoryList({ categoryHandle }: SubCategoryListProps) {
  const [subcategories, setSubcategories] = useState<SubCategory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSubCats() {
      try {
        setLoading(true);
        const res = await fetch(
          `/api/subcategories?category=${categoryHandle}`,
        );
        const json = await res.json();
        if (json.success) {
          // Filter unique by sub_handle just in case
          const unique = json.data.filter(
            (v: SubCategory, i: number, a: SubCategory[]) =>
              a.findIndex((t) => t.sub_handle === v.sub_handle) === i,
          );
          setSubcategories(unique);
        }
      } catch (error) {
        console.error("Failed to fetch subcategories", error);
      } finally {
        setLoading(false);
      }
    }
    if (categoryHandle) {
      fetchSubCats();
    }
  }, [categoryHandle]);

  if (!loading && subcategories.length === 0) return null;

  return (
  <div className="mb-12 overflow-hidden">
    <div className="relative">
      <div className="flex gap-4 animate-scroll">
        {[...subcategories, ...subcategories].map((sub, index) => (
          <div
            key={`${sub.sub_handle}-${index}`}
            className="min-w-[160px] md:min-w-[200px] lg:min-w-[220px]"
          >
            <Card className="border-none shadow-sm bg-white overflow-hidden text-center h-full">
              <div className="relative w-full aspect-[4/3] bg-gray-100">
                {sub.image_url ? (
                  <Image
                    src={sub.image_url}
                    alt={sub.sub_title}
                    fill
                    className="object-cover"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Image
                      src="/placeholder.svg"
                      alt={sub.sub_title}
                      width={64}
                      height={64}
                      className="object-contain opacity-60"
                    />
                  </div>
                )}
              </div>

              <CardContent className="p-3">
                <h3 className="font-semibold text-gray-800 text-sm md:text-base">
                  {sub.sub_title}
                </h3>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  </div>
);

}
